import * as React from 'react';
const h = React.createElement;

export interface AlertProps {
  type?: 'info' | 'success' | 'warning' | 'error';
  showIcon?: boolean;
  message: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

const iconMap: Record<string, string> = {
  info: '💡',
  success: '✅',
  warning: '⚠️',
  error: '❌',
};

const bgMap: Record<string, string> = {
  info: 'bg-blue-500/10 border-blue-500/30 text-blue-300',
  success: 'bg-green-500/10 border-green-500/30 text-green-300',
  warning: 'bg-yellow-500/10 border-yellow-500/30 text-yellow-300',
  error: 'bg-red-500/10 border-red-500/30 text-red-300',
};

const Alert: React.FC<AlertProps> = function Alert(props) {
  const { type = 'info', showIcon = false, message, style, className = '' } = props;
  return h(
    'div',
    {
      className: `flex items-start gap-2 px-4 py-3 rounded-md border text-sm ${bgMap[type]} ${className}`,
      style,
    },
    showIcon &&
      h('span', { className: 'mt-0.5 shrink-0' }, iconMap[type]),
    h('span', {}, message),
  );
};

export { Alert };
